// extracted by mini-css-extract-plugin
export var externalLink = "how-it-works-dr-module--external-link--63555";
export var fireTruck = "how-it-works-dr-module--fire-truck--552fd";
export var header = "how-it-works-dr-module--header--73377";
export var homeHowItWorks = "how-it-works-dr-module--home-how-it-works--72345";
export var homeHowItWorksBackground = "how-it-works-dr-module--home-how-it-works-background--569fe";
export var meteringSpeed = "how-it-works-dr-module--metering-speed--76398";
export var threeColumns = "how-it-works-dr-module--three-columns--bce80";
export var tools = "how-it-works-dr-module--tools--41aa2";
export var train = "how-it-works-dr-module--train--4a6ff";